import { render, staticRenderFns } from "./EmailLogDetail.vue?vue&type=template&id=480540b5&scoped=true&"
import script from "./EmailLogDetail.vue?vue&type=script&lang=js&"
export * from "./EmailLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogDetail.vue?vue&type=style&index=0&id=480540b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480540b5",
  null
  
)

export default component.exports